export default {"src":"/_next/static/image/public/images/ic_vector_right.bac0db440af787ac3e7e5843b6737e97.svg","height":36,"width":31};